import { t } from "i18next";

export const formatCheckinPeriod = (value: number | null | undefined) => {
  if (value == null) return <span style={{ color: "#aaa" }}>{t("30 minutes")}</span>;
  if (value === -1) return t("Unlimited");
  return t("_checkinPeriodUnits", { time: value });
};
